<template>
  <div>
    <oauth-wrapper
      :credentials.sync="credentials"
      :authorizeUrl="authorize_url"
      :tokenUrl="token_url"
      :logoutUrl="logout_url"
      :scope="scope"
      :client_id="client_id"
      :redirect_uri="redirect_uri"
      :loginIncrementor="loginIncrementor"
      :autologin="autologin"
      :debug="debug"
    >
      <page-layout-side-nav 
        :version="version" 
        :user="this.customLeftNav_userDetails" 
        :isShowMainMenuLink="true" 
        :navItems="items" 
        :isCustomTopNav="true"
        v-show="isLoggedIn"
      >
        <!-- <template v-slot:leftNavItems>
            <v-list nav dense>
              <v-list-item
                link
                v-for="(item, i) in items"
                :key="i"
                :to="item.link"
              >
                <v-list-item-action>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">{{ item.icon }}</v-icon>
                    </template>
                    <span>{{item.text}}</span>
                  </v-tooltip>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
        </template> -->
        
        <!-- <template v-slot:app-bar-settings>
          <v-btn icon small>
            <v-icon>mdi-access-point</v-icon>
          </v-btn>
          <v-btn icon small>
            <v-icon>mdi-airplane</v-icon>
          </v-btn>
        </template> -->
        
        
        <transition name="slide-right" mode="out-in" v-if="isLoggedIn">
            <router-view></router-view>
        </transition>
      </page-layout-side-nav> 
    </oauth-wrapper>
  </div>
</template>

<script>
import appSettingsMixin from "@/_mixins/app-settings-mixin"
import appMixin from "./mixins/app-mixin"
import pageLayoutSideNav from "@/_components/page-layouts/page-layout-side-nav";
import appOauthMixin from "./mixins/app-oauth-mixin";

export default {
  name: "CustomLeftNav",
  created()
  {
  },
  mixins : [appSettingsMixin,appMixin,appOauthMixin],
  components: {pageLayoutSideNav},
  computed: {
    items(){
      //filter items by the user role
      return this.settings.appNavigation.filter(x => !x.roles || x.roles.length === 0 || (this.user.roles && x.roles.filter(y => this.user.roles.includes(y)).length > 0));
    }
  },
  watch: {
    isLoggedIn(newVal){
      if(newVal){
        
        let userDetails = {
          userName: `${this.credentials["jwt-decode"].given_name} ${this.credentials["jwt-decode"].family_name}`,
          userEmail: ''
        }
        this.customLeftNav_userDetails = userDetails;
      }
    }
  },
  data: () => ({
    version: "0.1",
    user: {
      userName: "Chandanvandan, Avinash",
      roles: ["admin"] //used to filter Navigation items
    },
  }),
  methods: {},
};
</script>

<style lang="scss">
</style>
